/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestCaseOutputRead
 */
export interface TestCaseOutputRead {
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    test_case_id: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseOutputRead
     */
    points: number;
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    errors?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    parent_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseOutputRead
     */
    image_base64: string | null;
}

/**
 * Check if a given object implements the TestCaseOutputRead interface.
 */
export function instanceOfTestCaseOutputRead(value: object): value is TestCaseOutputRead {
    if (!('test_case_id' in value) || value['test_case_id'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('image_base64' in value) || value['image_base64'] === undefined) return false;
    return true;
}

export function TestCaseOutputReadFromJSON(json: any): TestCaseOutputRead {
    return TestCaseOutputReadFromJSONTyped(json, false);
}

export function TestCaseOutputReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseOutputRead {
    if (json == null) {
        return json;
    }
    return {
        
        'test_case_id': json['test_case_id'],
        'points': json['points'],
        'text': json['text'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'id': json['id'],
        'image_base64': json['image_base64'],
    };
}

export function TestCaseOutputReadToJSON(json: any): TestCaseOutputRead {
    return TestCaseOutputReadToJSONTyped(json, false);
}

export function TestCaseOutputReadToJSONTyped(value?: TestCaseOutputRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'test_case_id': value['test_case_id'],
        'points': value['points'],
        'text': value['text'],
        'errors': value['errors'],
        'parent_id': value['parent_id'],
        'id': value['id'],
        'image_base64': value['image_base64'],
    };
}

